/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link, withRouter} from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input,
} from "reactstrap";

import routes from "routes.js";
import url from "variables/url.js";
import { setCookie, getCookie, deleteCookie, checkCookie } from "variables/espolAds.js";

import { AppContext } from './../../AppContext';

/*'https://auth.espol.edu.ec/logout?service=http://localhost:44397'*/
/*'https://auth.espol.edu.ec/logout?service=http://200.10.147.25/general/principal'*/

import CasClient, { constant } from "react-cas-client";
import { authService } from '../../services/auth.service';
const CAS_PARAMS = url.cas.split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PARAMS[0] };
const casClient = new CasClient(CAS_PARAMS[1], casOptions);

const localFront = url.localFront;
/*const localFront = 'http://200.10.147.25/';*/
const addsuscripcion = localFront + 'add-suscripcion';
const out = url.cas + '/logout?service=' + localFront + 'general/principal';
const log = 'https://auth.espol.edu.ec/login?service=' + localFront + 'logCas';
const redirectPath = 'general/principal';

class Header extends React.Component {
  state = {
    isOpen: false,
    dropdownOpen: false,
    color: "transparent",
    
  };
  sidebarToggle = React.createRef();
  toggle = () => {
    if (this.state.isOpen) {
      this.setState({
        color: "transparent",
      });
    } else {
      this.setState({
        color: "white",
      });
    }
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };
  dropdownToggle = (e) => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  };
  getBrand = () => {
    var name;
    routes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        } else {
          if (prop.path === this.props.location.pathname) {
            name = prop.name;
          }
        }
      }
      return null;
    });
    return name;
  };
  openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    this.sidebarToggle.current.classList.toggle("toggled");
  };
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.isOpen) {
      this.setState({
          color: "white",
          username: null,
          currentUser: null
      });
    } else {
      this.setState({
          color: "transparent",
          username: null,
          currentUser: null
      });
    }
  };
  componentDidMount() {
      window.addEventListener("resize", this.updateColor.bind(this));      
  }
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      this.sidebarToggle.current.classList.toggle("toggled");
      }          
    } 
    
    logOut() {
        sessionStorage.clear();
        deleteCookie("userEspol");
        deleteCookie("username");
        deleteCookie("token");
        deleteCookie("isAdmin");
        deleteCookie("isRev");
        deleteCookie("isCreator");
        deleteCookie("expiration");
        casClient.logout(localFront + redirectPath);
        /*localStorage.clear();*/
        /*window.location.href = '/';*/
    }    
    logoutCas() {
        /*console.log("LogOut");*/
        /*console.log(out);*/
        /*casClient.logout(redirectPath);*/
        this.logOut();
        window.location.href = out;
    }
    loginCas() {
        const currentUser = this.context;        
        if (currentUser) {           
            //console.log(currentUser.usuario);
            //console.log(currentUser.nombre);
            //console.log(currentUser.apellido);
        }        
        if (!getCookie('userEspol')) {
            casClient
                .auth()
                .then(successRes => {
                    /*console.log("App successRes = " + JSON.stringify(successRes)); this.setState({ username: successRes.user });*/
                    authService.login(successRes.user);
                    /*console.log(this.props.location.pathname);*/
                })
                .catch(errorRes => { /*console.log("App errorRes = " + JSON.stringify(errorRes))*/ });
        }
        /*console.log(this.state.currentUser);*/
        this.subscription = authService.currentUser.subscribe(currentUser => {
            if (currentUser && currentUser.usuario) {
                this.setState({ currentUser: currentUser });
                //console.log(this.state.currentUser.roles);
                //console.log(this.state.currentUser.usuario);
            }
        });
    }
  render() {
    return (
      // add or remove classes depending if we are on full-screen-maps page or not
      <Navbar
        color={
          this.props.location.pathname.indexOf("full-screen-maps") !== -1
            ? "white"
            : this.state.color
        }
        expand="lg"
        className={
          this.props.location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute fixed-top"
            : "navbar-absolute fixed-top " +
              (this.state.color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <Container fluid>
          <div className="navbar-wrapper">
                    <div className="navbar-toggle">
                        <button id="hamburger" title="hamburger"
                type="button"
                ref={this.sidebarToggle}
                className="navbar-toggler"
                onClick={() => this.openSidebar()}
              >
                <span className="navbar-toggler-barEA bar1" />
                <span className="navbar-toggler-barEA bar2" />
                <span className="navbar-toggler-barEA bar3" />
               </button>
            </div>
            <NavbarBrand href="/">{this.getBrand()}</NavbarBrand>
          </div>
          <NavbarToggler onClick={this.toggle}>
                    <span className="navbar-toggler-barEA navbar-kebab" />
                    <span className="navbar-toggler-barEA navbar-kebab" />
                    <span className="navbar-toggler-barEA navbar-kebab" />
          </NavbarToggler>
          <Collapse
            isOpen={this.state.isOpen}
            navbar
            className="justify-content-end"
          >
                    {/*<form className="form-80">
                        <InputGroup className="no-border">
                            <Input placeholder="Buscar..." />
                            <InputGroupAddon addonType="append">
                                <InputGroupText>
                                    <i className="now-ui-icons ui-1_zoom-bold" />
                                </InputGroupText>
                            </InputGroupAddon>
                        </InputGroup>
                    </form>*/}
                    <Nav navbar>
                        {/*{sessionStorage.getItem('username') != null ?*/}
                        {checkCookie('userEspol') ?
              <Dropdown
                nav
                isOpen={this.state.dropdownOpen}
                toggle={(e) => this.dropdownToggle(e)}
              >
                <DropdownToggle caret nav>
                  <i className="now-ui-icons users_single-02" />                  
                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem hidden tag="a"><a href={addsuscripcion} className="nav-link">Mis Preferencias</a></DropdownItem>
                                    <DropdownItem tag="a" onClick={() => this.logoutCas()}  ><a className="nav-link">Salir</a></DropdownItem>
                </DropdownMenu>
              </Dropdown>
                            : <></>}
                        <NavItem>
                            {/*{sessionStorage.getItem('username') == null || sessionStorage.getItem('username') == "" ?*/}
                            {!checkCookie('userEspol') ?
                                <a className="nav-link" onClick={() => this.loginCas()}>
                  <i className="now-ui-icons users_single-02" />
                  <p>
                    <span className="edit-icon" >Iniciar Sesi&oacute;n</span>
                  </p>
                                </a> :
                                <Link className="nav-link">
                                    <i className="now-ui-icons users_single-02" />
                                    <p>
                                        {/*<span className="">{sessionStorage.getItem('username')}</span>*/}
                                        <span className="">{getCookie('userEspol')}</span>
                                    </p>
                                </Link>}
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

//export default Header;
Header.contextType = AppContext;
export default withRouter(Header);

